var exports = {
  "CB": "RoleManagement.module__roleIndicator___eEt5RE",
  "KG": "RoleManagement.module__roleBadge___eEt5RE",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___eEt5RE",
  "j1": "RoleManagement.module__roleRemoveButton___eEt5RE",
  "r4": "RoleManagement.module__roleRemoveIconContainer___eEt5RE",
  "S3": "RoleManagement.module__roleName___eEt5RE",
  "MR": "RoleManagement.module__roleListContainer___eEt5RE",
  "ek": "RoleManagement.module__assignRoleButton___eEt5RE",
  "JO": "RoleManagement.module__assignRoleButtonIcon___eEt5RE",
  "RK": "RoleManagement.module__iconSize___eEt5RE",
  "Xk": "RoleManagement.module__noRolesLink___eEt5RE",
  "X9": "RoleManagement.module__roleColorIndicator___eEt5RE",
};

module.exports = exports;
